import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import warning_icon from '../../assets/images/warning_icon.svg';

const FutureDateWarningPopup = ({
    show,
    onHide,
    onConfirm,
    message = "You are calculating the future date range payroll."
}) => {
    return (
        <Modal show={show} onHide={onHide} centered className="future_date_warning_popup">
            <Modal.Body>
                <div className="dd_counfirm_popup text-center pt-4">
                    <img src={warning_icon} alt="Warning" className="mb_20" />
                    <h6 className="my_10">Future Date Range Warning</h6>
                    <p>{message}</p>
                </div>
            </Modal.Body>

            <Modal.Footer className="text-center d-flex justify-content-center">
                <Button variant="secondary" onClick={onHide} className="btn_cancel my-0">
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    className="btn_primary my-0 border-0"
                    onClick={onConfirm}
                >
                    Proceed
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FutureDateWarningPopup;
